module.exports = __webpack_public_path__ + "media/components/admin/navigation/static/logout-c7604d0ac6d99c27d165bd04465e6b05.svg";